export default __webpack_public_path__ + "static/media/new_logo.e752e4a3.svg";